module.exports = __webpack_public_path__ + "img/app-work.13c17e00.png";